<div class="row columns payment-iframe">
	<div class="row columns">
		<h1>{{ paymentHeadline() | translate }}</h1>
	</div>

	<iframe [src]="donation.paymentUrl | safeUrl" [id]="twingleID" scrolling="yes"></iframe>

	<!-- Button -->
	<div class="row columns">
			<submit [text]="paymentSubmitTextkey | translate: buttonPlaceholders" [arrow]="false" (click)="submitIframe()" [secureText]="'payment.submit.hint' | translate"></submit>
	</div>
</div>
